<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;"><span class="bold"><em class="italic">Contents</em></span></h2>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName1" style="text-indent: 0%;"><a href="#/9781429983952_pt01#pt01">PART ONE</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><a href="#/9781429983952_ch01#ch01">1 Work Ethics</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch02#ch02" title="Link target outside of Sample">2 Why</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch03#ch03" title="Link target outside of Sample">3 Truth</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch04#ch04" title="Link target outside of Sample">4 Shame</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch05#ch05" title="Link target outside of Sample">5 Welcome</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch06#ch06" title="Link target outside of Sample">6 Improvise</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch07#ch07" title="Link target outside of Sample">7 September 5th</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch08#ch08" title="Link target outside of Sample">8 Beauty</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch09#ch09" title="Link target outside of Sample">9 Revelation</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName1" style="text-indent: 0%;"><span href="#/9781429983952_pt02#pt02" title="Link target outside of Sample">PART TWO</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch10#ch10" title="Link target outside of Sample">10 Home</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch11#ch11" title="Link target outside of Sample">11 Courtship</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch12#ch12" title="Link target outside of Sample">12 Tipping Point</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch13#ch13" title="Link target outside of Sample">13 Steps</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch14#ch14" title="Link target outside of Sample">14 Distortion</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch15#ch15" title="Link target outside of Sample">15 Domestic Violence</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName1" style="text-indent: 0%;"><span href="#/9781429983952_pt03#pt03" title="Link target outside of Sample">PART THREE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch16#ch16" title="Link target outside of Sample">16 Identity</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch17#ch17" title="Link target outside of Sample">17 Repast</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%; margin-left: 5%;"><span href="#/9781429983952_ch18#ch18" title="Link target outside of Sample">18 Concertina</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781429983952_ack#ack" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983952_con01.vue?177bf50a